import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Recover from "slotworks/state-machine/standard/states/recover";

// Jump the reels to the root spin records grid
export default class RecoverMatrix extends Recover {
    public onEnter() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getRootRecord();

        if (record instanceof SpinRecord && record.grid) {
            Components.matrix.jumpToGrid(record.grid);
        }

        super.onEnter();
    }
}
